import { useEffect, useState, useRef } from "react";
import Header from "../../common/Header";
import CommonValues, { Logout } from "../../common/utils";
import AtkLoader from "../../AtlaskitControls/AtkLoader";
import AtkTextField from "../../AtlaskitControls/AtkTextField";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { Dropdown } from "primereact/dropdown";
import AtkButtonIconBefore from "../../AtlaskitControls/AtkButtonIconBefore";
import Magnifier from "../../assets/images/MagnifierIcon.png";
import AtkIcon from "../../AtlaskitControls/AtkIcon";
import MiddleHeader from "../../common/MiddleHeader";
import Sidebar from "../../common/Sidebar";
import Footer from "../../common/Footer";
import ResponseTable from "./ResponseTable";
import BackIcon from "../../assets/images/Back Button.svg";
import { Toast } from "primereact/toast";
import AtkMessage from "../../AtlaskitControls/AtkMessage";

export default function PFSavedQuotes() {
  const navigate = useNavigate();
  const [premiumHistoryLoading, setPremiumHistoryLoading] = useState(true);
  const [historyData, setHistoryData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [fromDate, setFromDate] = useState<any>("");
  const [toDate, setToDate] = useState<any>("");
  const [selectList, setSelectList] = useState<any>([]);
  const [clientName, setClientName] = useState("");
  const [partnerListLoading, setPartnerListLoading] = useState(false);
  const [partnerList, setPartnerList] = useState<any>([]);
  const [partner, setPartner] = useState({ id: null, name: "All" });
  const toast: any = useRef("");

  useEffect(() => {
    const token = CommonValues.GetToken();
    if (token == "" || token == null) {
      CommonValues.Logout(navigate);
    }
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    setToDate(new Date().toISOString().substring(0, 10));
    setFromDate(oneMonthAgo.toISOString().substring(0, 10));
    getPremiumFinanceSavedHistory(oneMonthAgo.toISOString().substring(0, 10), new Date().toISOString().substring(0, 10));
    getPremiumFinanceSettings();
  }, []);

  const getPremiumFinanceSavedHistory = (fmDate: any, tDate: any) => {
    setPremiumHistoryLoading(true);
    var token = CommonValues.GetToken();

    var data = JSON.stringify({
      FromDate: fmDate,
      ToDate: tDate,
      PartnerIds: selectList,
      ClientName: clientName,
    });
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/PremiumFinance/savedhistory`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        if (response.data && response.data.length > 0) {
          const updatedHistoryData = response.data.map((item:any) => ({
              ...item,
              selectedPolicyIndex: item.policyIndex 
          }));
          setHistoryData(updatedHistoryData);
      }
        setPremiumHistoryLoading(false);
        setErrorMessage("");
      })
      .catch((error: any) => {
        let errorMessage = "";
        if (error.response != null) {
          if (error.response.status == 401) {
            navigate("/");
            CommonValues.Logout(navigate);
          } else {
            errorMessage = "Unknown error while loading the Premium finance saved history ";
          }
        } else {
          errorMessage = "Unknown error while loading the Premium finance saved history ";
        }
        setPremiumHistoryLoading(false);
        setErrorMessage(errorMessage);
      });
  };
  const handleFromDateChange = (event: any) => {
    setFromDate(event.target.value);
  };
  const handleToDateChange = (event: any) => {
    setToDate(event.target.value);
  };
  const onClientNameChange = (event: any) => {
    if (event.target.value.length > 255) {
      return;
  }
    setClientName(event.target.value);
  };
  const partnerListDropdownClicked = (e: any) => {
    const selectedOption = e.target.value;
    if (selectedOption === "All") {
      setPartner(selectedOption);
      setSelectList([]);
    } else {
      setPartner(selectedOption);
      const selectedPartner = partnerList.find((partner: any) => partner.name == selectedOption.name);
      if (selectedPartner) {
        setSelectList(selectedPartner.id !== null ? [selectedPartner.id] : []);
      }
    }
  };
  const getPremiumFinanceSettings = () => {
    setPartnerListLoading(true);
    var token = CommonValues.GetToken();

    var config = {
      method: "get",
      url: `${process.env.REACT_APP_UserService_Url}/api/user/savedquotespartnerlist`,

      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        setErrorMessage("");
        const allOption = { id: null, name: "All" };
        const updatedPartnerList = [allOption, ...response.data];
        setPartnerList(updatedPartnerList);
        setPartner(allOption);
        setPartnerListLoading(false);
      })
      .catch((error: any) => {
        let errorMessage = "";
        if (error.response != null) {
          if (error.response.status == 401) {
            navigate("/");
            CommonValues.Logout(navigate);
          } else {
            errorMessage = "Unknown error while loading the Premium finance Setting details";
          }
        } else {
          errorMessage = "Unknown error while loading the Premium finance Setting details";
        }
        setPartnerListLoading(false);
        setErrorMessage(errorMessage);
      });
  };
  const isValid = () => {
    let valid = true;
    if (fromDate == null || fromDate == "") {
      toast.current.show({ severity: "error", detail: "Please select from date", life: 5000 });
      valid = false;
    }
    if (toDate == null || toDate == "") {
      toast.current.show({ severity: "error", detail: "Please select to date", life: 5000 });
      valid = false;
    }
    if (fromDate > toDate) {
      toast.current.show({ severity: "error", detail: "To date must be greater than from date", life: 5000 });
      valid = false;
    }
    return valid;
  };
  const OnSearch = (e: any) => {
    if (e.keyCode == 13) {
      if (isValid()) {
        getPremiumFinanceSavedHistory(fromDate, toDate);
        setCurrentPage(1);
      }
    }
  };
  const onSearchClick = () => {
    if (isValid()) {
      getPremiumFinanceSavedHistory(fromDate, toDate);
      setCurrentPage(1);
    }
  };
  const onBackButtonClick = () => {
    navigate("/landingPage");
  };
  return (
    <>
      <Toast ref={toast} />
      <div className="pf-saved-quote-main-page">
        <Header />
        <div className="content-wrapper ">
          <div className="row  wrapper-main-row mx-auto wrapper-below-div">
            <div className="col-12">
              <MiddleHeader />
            </div>
            <div className="row main-content-row mx-auto">
              <div className="col-lg-2 col-md-3 sidebar-col display-for-desktop">
                <Sidebar pageName="SavedQuotespage" />
              </div>

              <div className="col-lg-10 col-md-12 col-sm-12 main-content-col ">
                <div className="row history-search-row d-flex  align-items-end text-12 position-relative">
                  {/* <div className="col-lg col-md  col-sm col my-1 back-btn-div">
                    <img src={BackIcon} className="show-cursor" height={20} width={20} onClick={onBackButtonClick} />
                  </div> */}
                  <div className="col-lg-2  col-md-6 col-sm-6  col-6 my-1 ">
                    <label className="me-2 mb-1">From Date</label>

                    <AtkTextField
                      type="date"
                      id="datepicker"
                      className="input-field"
                      name="fromDate"
                      onChange={handleFromDateChange}
                      value={fromDate}
                      max={new Date().toISOString().substring(0, 10)}

                    />
                  </div>
                  <div className="col-lg-2  col-md-6 col-sm-6  col-6 my-1  ">
                    <label className="me-2 mb-1">To Date</label>
                    <AtkTextField
                      type="date"
                      id="datepicker"
                      name="toDate"
                      onChange={handleToDateChange}
                      value={toDate}
                      onKeyDown={() => {}}
                      placeholder=""
                      className="input-field"
                      max={toDate}
                    />
                  </div>

                  <div className="col-lg-3 col-md-5 col-sm-12  col-12 my-1 ">
                    <label className="me-2 mb-1">Finance Company</label>{" "}
                    {partnerListLoading ? (
                      <div className="text-center">
                        <AtkLoader />
                      </div>
                    ) : (
                      <Dropdown
                        type="text"
                        id="text"
                        className="finance-company-dropdown input-field"
                        value={partner}
                        onChange={partnerListDropdownClicked}
                        optionLabel="name"
                        options={partnerList}
                        placeholder="Finance Company"
                      />
                    )}
                  </div>
                  <div className="col-lg-3 col-md-5 col-sm-8  col-8 my-1  ">
                    <label className="me-2 mb-1">Client Name</label>

                    <AtkTextField
                      type="text"
                      id="text"
                      name="clientName"
                      onChange={onClientNameChange}
                      value={clientName}
                      placeholder="Search by client name"
                      className="input-field"
                      onKeyDown={OnSearch}
                    />
                  </div>
                  <div className="col-lg col-md col-sm-4 col-4 my-1 history-searchbtn-div">
                    <AtkButtonIconBefore
                      label="Search"
                      iconBefore={<AtkIcon icon={Magnifier} />}
                      className="pf-primary-btn"
                      onClick={onSearchClick}
                      onKeyDown={OnSearch}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 history-table p-0">
                    {premiumHistoryLoading ? (
                      <div className="d-flex align-items-center justify-content-center mt-2">
                        <AtkLoader />
                      </div>
                    ) : (
                      <>
                        {historyData.length > 0 ? (
                          <ResponseTable
                            tableValue={historyData}
                            getPremiumFinanceSavedHistory={() => getPremiumFinanceSavedHistory(fromDate, toDate)}
                          />
                        ) : (
                          <div className="col-12 mt-3 history-unavailable ">
                            <AtkMessage appearance="information" messageText={"No saved quotes found"} />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
